export  default {
  addSite(state, payload) {
    state.newSite = payload;
  },
  decommissionSite(state, payload) {
    state.decommissionSite = payload;
  },
  switchDevice(state, payload) {
    state.switchDevice = payload;
  },
  setBulkImportResults(state, payload) {
    state.bulkImportResults = payload;
  }
};